import styles from "./Fieldset.module.scss";
import { ReactNode } from "react";
import { Flex } from "../flex/Flex";
import { AlertCircleIcon } from "@vetty/icons";

const Fieldset = ({
  children,
  isError = false,
  errorMessage = "",
  className,
  align = "start",
}: {
  children: ReactNode;
  isError?: boolean | string;
  errorMessage?: string;
  className?: string;
  align?: "start" | "center" | "end";
}) => {
  return (
    <fieldset className={styles["comp"]}>
      <div className={className}>{children}</div>

      {isError && (
        <Flex
          align={"center"}
          justify={align}
          gap={6}
          className={styles["comp__error"]}
        >
          <AlertCircleIcon />
          <span>{errorMessage}</span>
        </Flex>
      )}
    </fieldset>
  );
};

export { Fieldset };
